import { BrowserWebSocketClientAdapter, JoinMessage } from "@automerge/automerge-repo-network-websocket";
import {
    type PeerId,
    type PeerMetadata,
  } from "@automerge/automerge-repo"
import { App } from "vue";


export class FoliaBrowserWebsocketClientAdaptor extends BrowserWebSocketClientAdapter {

    $fetch: any;
    $auth0: any;
    connectionIssueNoticed: boolean = false;
    baseUrl: string = ""
    private _isRefreshingToken: boolean = false;

    constructor(url: string, app: App) {
        super(url)
        this.baseUrl = url
        this.$fetch = app.config.globalProperties.$fetch;
        this.$auth0 = app.config.globalProperties.$auth0;
    }

    connect(peerId: PeerId, peerMetadata: PeerMetadata) {
        console.log("Connecting automerge repo to sync server.....")

        // The parent only removes listeners from the old socket but never calls
        // .close() on it, which leaves CONNECTING/OPEN sockets dangling on the
        // server. Strip listeners first (so the close event doesn't re-trigger
        // onClose), then explicitly close before super creates the new socket.
        if (this.socket &&
            this.socket.readyState !== WebSocket.CLOSED &&
            this.socket.readyState !== WebSocket.CLOSING) {
            this.socket.removeEventListener("open", this.onOpen)
            this.socket.removeEventListener("close", this.onClose)
            this.socket.removeEventListener("message", this.onMessage)
            this.socket.close()
        }

        this.url = this.baseUrl + "?Authentication=" + localStorage.getItem("accessToken")
        super.connect(peerId, peerMetadata);
    }

    /**
     * Refreshes the Auth0 token (updates localStorage) before reconnecting.
     * Used on close/reconnect so an expired token doesn't cause an infinite
     * loop of rejected WebSocket connections.
     */
    private async connectWithFreshToken(peerId: PeerId, peerMetadata: PeerMetadata) {
        if (this._isRefreshingToken) return;
        this._isRefreshingToken = true;
        try {
            await this.$auth0.getUser(); // calls getTokenSilently() → updates localStorage
        } catch (e) {
            console.warn("Automerge: token refresh failed before reconnect", e);
        } finally {
            this._isRefreshingToken = false;
        }
        this.connect(peerId, peerMetadata);
    }

    disconnect() {
        console.log("Disconnected sync server")
        super.disconnect()
    }

    onClose = () => {
        console.log("Closed sync connection")

        if (this.remotePeerId) {
            this.emit("peer-disconnected", { peerId: this.remotePeerId })
        }

        if (!this.connectionIssueNoticed) {

            /*if (this.offlineRetryCount > 5) {
                this.$fetch.dispatch(BROADCAST_MESSAGE.TOAST, {
                    type: OFFLINE_TOAST,
                    close_timeout: 30_000,
                    title: "You are now offline",
                    message: "You are no longer connected to Folia servers. Check your network and refresh the page ",
                });
            }*/
            this.connectionIssueNoticed = true;
        }

        if (!this.timerId) {
            if (this.peerId) {
                this.connectWithFreshToken(this.peerId, this.peerMetadata!);
            }
        }
    }

    onOpen = () => {
        console.log("On websocket connection open");
        // console.log(this.timerId)

        clearInterval(this.timerId)
        // console.log("Time id after clear")
        // console.log(this.timerId)
        this.timerId = undefined
        // console.log("Sending a join message " + this.peerId!);
        this.send(this.joinMessage(this.peerId!, this.peerMetadata!))
        if (this.connectionIssueNoticed) {
            /*this.$fetch.dispatch(BROADCAST_MESSAGE.TOAST, {
                type: SUCCESS_TOAST,
                close_timeout: 30_000,
                title: "Connection established",
                message: "You are connected back to Folia servers. Please refresh the page",
            });*/
            this.connectionIssueNoticed = false;
        }
    }


    joinMessage(senderId: PeerId,peerMetadata: PeerMetadata): JoinMessage {
        return {
            type: "join",
            senderId,
            peerMetadata,
            supportedProtocolVersions: ["1"],
        }
    }



}
